import log from 'salvo-lite/log'
import Helpers from '../helpers/Helpers'

class InputHelper {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._inputs = null
        this._cfForms = elem.querySelectorAll('[data-cf-form]')
    }

    _refresh () {
        this._inputs = this._elem.querySelectorAll('input:not([data-input-helper-initiated]),select:not([data-input-helper-initiated])')
        for (let input of this._inputs) {
            input.addEventListener('input', e => {
                this._checkValueLength(input)
            })
            input.addEventListener('focusin', e => {
                input.classList.add('input--has-focus')
                input.parentElement.classList.add('input--has-focus')
                this._checkValueLength(input)
            })
            input.addEventListener('focusout', e => {
                input.classList.remove('input--has-focus')
                input.parentElement.classList.remove('input--has-focus')
                this._checkValueLength(input)
            })
            this._checkValueLength(input)
            input.dataset.inputHelperInitiated = true
        }
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')
        this._refresh()

        for (let form of this._cfForms) {
            let config = { attributes: false, childList: true, subtree: true }
            let observer = new MutationObserver((mutationsList, subObserver) => {
                if (form.querySelector('.cf-field')) {
                    console.log('found')
                    this._refresh()
                }
            })
            observer.observe(this._elem, config)
        }
        log.debug(this.constructor.name, 'Initiated')
    }

    _checkValueLength (input) {
        if (input.value.length > 0) {
            input.classList.add('input--has-value')
            input.parentElement.classList.add('input--has-value')
        } else {
            input.classList.remove('input--has-value')
            input.parentElement.classList.remove('input--has-value')
        }

        Helpers.nextFrame(() => {
            input.classList.add('input--can-animate')
            input.parentElement.classList.add('input--can-animate')
        })
    }
}

export default InputHelper



// WEBPACK FOOTER //
// ./src/resources/scripts/components/InputHelper.js